"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
var Status;
(function (Status) {
    Status[Status["Idle"] = 0] = "Idle";
    Status[Status["Waiting"] = 5] = "Waiting";
    Status[Status["Creating"] = 10] = "Creating";
    Status[Status["FetchingRefSystem"] = 13] = "FetchingRefSystem";
    Status[Status["FetchingTestSystem"] = 16] = "FetchingTestSystem";
    Status[Status["Calculating"] = 20] = "Calculating";
    Status[Status["Comparing"] = 30] = "Comparing";
    Status[Status["Complete"] = 50] = "Complete";
})(Status || (exports.Status = Status = {}));
//# sourceMappingURL=types.js.map